"use client"
/* */
import { useLocalizedStringFormatter } from 'react-aria';

const Translate = (props) => {
  const { children, locales, variables } = props;
  const translator = useLocalizedStringFormatter(locales);
  return translator.format(children, variables);
};

export { Translate, Translate as default };
//# sourceMappingURL=Translate.mjs.map
